import { useState } from 'react';
import { Check, Copy, Loader2 } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

/**
 * Row count for report filter bars; clicking copies the number. Passing
 * `loadingHint` adds a spinner and shows the hint in place of the tooltip.
 */
export function CopyCountButton({ count, label, loadingHint }: {
  count: number;
  label: string;
  loadingHint?: string;
}) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    void navigator.clipboard.writeText(String(count));
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={handleCopy}
            className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"
          >
            {copied ? <Check className="size-3.5 text-green-600" /> : <Copy className="size-3.5" />}
            <span className="font-mono font-medium">{count.toLocaleString()}</span>
            <span>{label}</span>
            {loadingHint && <Loader2 className="size-3.5 animate-spin" />}
          </button>
        </TooltipTrigger>
        <TooltipContent>{loadingHint ?? 'Click to copy count'}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
